import { render, staticRenderFns } from "./NakedLayout.vue?vue&type=template&id=efeb6564&lang=pug&"
import script from "./NakedLayout.vue?vue&type=script&lang=js&"
export * from "./NakedLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports